import { BrowserModule } from '@angular/platform-browser';
import { NgModule, InjectionToken } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { DataService } from './shared/dataService';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';
import { RoleGuardService } from './auth/role-guard.service';
import { TokenInterceptor } from './auth/token-interceptor.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { DashboardPage } from './pages/dashboardpage/dashboardPage.component';
import { JobOffersPage } from './pages/jobofferspage/jobofferspage.component';
import { JobOfferPage } from './pages/jobofferpage/jobofferpage.component';
import { LoginPage } from './pages/loginpage/loginpage.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';

let routes = [
    { path: "dashboard", component: DashboardPage, canActivate: [AuthGuard] },
    { path: "vacatures", component: JobOffersPage, canActivate: [AuthGuard], pathMatch: 'full' },
    { path: "vacatures/:id", component: JobOfferPage, canActivate: [AuthGuard] },
    
    { path: "login", component: LoginPage },
    { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
    declarations: [
        AppComponent,
        JobOffersPage,
        JobOfferPage,
        DashboardPage,
        LoginPage,
        ConfirmationDialogComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        HttpClientModule,
        RouterModule.forRoot(routes, {
            enableTracing: false, //debugging
        }),
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        CKEditorModule,
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot() // ToastrModule added
    ],
    providers: [
        {provide: APP_BASE_HREF, useValue: '/admin/'},
        AuthGuard,
        TokenInterceptor,
        RoleGuardService,
        DataService,
        ConfirmationDialogService
    ],
    entryComponents: [ConfirmationDialogComponent],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }


